import React, {useEffect, useState} from "react";
import styles from "./AddArticle.module.css";
import {Alert, Button, Grid2} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {StepDescription} from "../../../register/Register";
import {useSectionsRefs} from "../../../../components/mainWrapper/MainWrapper";
import RegisterStepper from "../../../../components/registerStepper/RegisterStepper";
import PersonnalData from "../../../../components/registerStepper/personnalData/PersonnalData";
import RegistrationConfirmationStep
    from "../../../../components/registerStepper/registrationConfirmationStep/RegistrationConfirmationStep";
import useDataPost from "../../../../hooks/useDataPost";
import useDataFetch from "../../../../hooks/useDataFetch";
import {SocietyDTO} from "../../../../context/SocietyProvider";
import ArticleDetailsDefinition from "./articleDetailsDefinition/ArticleDetailsDefinition";
import ArticlesImagesDefinition from "./articlesImagesDefinition/ArticlesImagesDefinition";
import ArticlesVariantsDefinition from "./articleVariantsDefinition/ArticlesVariantsDefinition";

export interface StepDescriptionDataValidation {
    validationMethod: () => Promise<boolean>,
}

export interface SuccessfullRegisterResponseDTO {
    email: string,
}

const AddArticle = () => {

    const {
        isLoading,
        data,
        postData
    } = useDataPost<SuccessfullRegisterResponseDTO>(`/auth/register`, {}, false, false, false);

    const [activeStep, setActiveStep] = useState<number>(0);

    const [error, setError] = useState<string>('');

    const stepsDescriptions: StepDescription[] = [
        {
            stepTitle: "Détails de l'article",
            stepNumber: 2,
            stepComponent: (
                <ArticleDetailsDefinition/>
            ),
            stepDescriptionDataValidation: [],
        },
        {
            stepTitle: "Images d'illustration",
            stepNumber: 1,
            isOptional: true,
            stepComponent: (
                <ArticlesImagesDefinition/>
            ),
            stepDescriptionDataValidation: [],
        },
        {
            stepTitle: "Variantes",
            stepNumber: 0,
            isOptional: true,
            stepComponent: (
                <ArticlesVariantsDefinition/>
            ),
            stepDescriptionDataValidation: []
        },
    ]

    const handleNext = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const currentStepDescriptionDataValidation = stepsDescriptions[activeStep].stepDescriptionDataValidation;

        let isDataValid = true;
        for (const dataValidation of currentStepDescriptionDataValidation) {
            const isValid = await dataValidation.validationMethod();
            if (!isValid) {
                isDataValid = false;
                break;
            }
        }

        if (!isDataValid) {
            return;
        }

        if (activeStep < stepsDescriptions.length - 1) {
            setActiveStep(activeStep + 1);
        }

        if (activeStep === stepsDescriptions.length - 1) {
            const data = {}

            postData(undefined, data);
        }
    }

    const handleBack = () => {
        setError('');
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
        }
    }

    return (
        <Box sx={{
            width: "100%",
            backgroundColor: 'primary.main',
            alignContent: 'center'
        }}>

            <Box
                sx={{
                    backgroundColor: "primary.main",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div className={styles.content}>
                    <div className={styles.realContent}>
                        {!data ? (
                            <>
                                <RegisterStepper activeStep={activeStep} stepsDescriptions={stepsDescriptions.sort((a, b) => a.stepNumber - b.stepNumber)}/>
                                <Box
                                    sx={{
                                        pl: "10px",
                                        pr: "10px",
                                        pb: "10px",
                                    }}
                                >
                                    <form onSubmit={(e) => handleNext(e)}>
                                        <Typography
                                            variant={"secondVariant"}
                                            sx={{
                                                fontSize: {xs: 22},
                                                display: {xs: 'block', sm: 'none'},
                                                mb: 3,
                                            }}
                                        >
                                            {stepsDescriptions[activeStep].stepTitle}
                                        </Typography>

                                        {stepsDescriptions[activeStep].stepComponent}

                                        {error && (
                                            <Alert
                                                severity="error"
                                                sx={{mb: 4}}
                                            >
                                                {error}
                                            </Alert>
                                        )}

                                        <Grid2 container>
                                            <Grid2 size={6} textAlign={"left"}>
                                                <Button
                                                    sx={{
                                                        display: activeStep > 0 ? 'block' : 'none'
                                                    }}
                                                    onClick={() => handleBack()}
                                                    variant={"fourthVariant"}
                                                >
                                                    Précédent
                                                </Button>
                                            </Grid2>
                                            <Grid2 size={6} textAlign={"right"}>
                                                <Button
                                                    type={"submit"}
                                                    variant={"fourthVariant"}
                                                    disabled={isLoading}
                                                >
                                                    {activeStep === stepsDescriptions.length - 1 ? 'Valider' : 'Suivant'}
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    </form>
                                </Box>
                            </>
                        ) : (
                            <RegistrationConfirmationStep email={data.email}/>
                        )}

                    </div>
                </div>
            </Box>
        </Box>

    );
}

export default AddArticle